/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Upload_Error_TypeInputs */

const en_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsupported file type. Please upload a PDF or DOCX file.`)
};

const de_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht unterstuetzter Dateityp. Bitte lade eine PDF- oder DOCX-Datei hoch.`)
};

const fr_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de fichier non pris en charge. Veuillez telecharger un fichier PDF ou DOCX.`)
};

const es_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de archivo no compatible. Sube un archivo PDF o DOCX.`)
};

const it_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di file non supportato. Carica un file PDF o DOCX.`)
};

const nl_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet-ondersteund bestandstype. Upload een PDF- of DOCX-bestand.`)
};

const pl_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieobslugiwany typ pliku. Prosze przeslac plik PDF lub DOCX.`)
};

const fi_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedostotyyppiä ei tueta. Lataa PDF- tai DOCX-tiedosto.`)
};

const da_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke-understottet filtype. Upload venligst en PDF- eller DOCX-fil.`)
};

const sv_onboarding_upload_error_type = /** @type {(inputs: Onboarding_Upload_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtypen stods ej. Ladda upp en PDF- eller DOCX-fil.`)
};

/**
* | output |
* | --- |
* | "Unsupported file type. Please upload a PDF or DOCX file." |
*
* @param {Onboarding_Upload_Error_TypeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_upload_error_type = /** @type {((inputs?: Onboarding_Upload_Error_TypeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Upload_Error_TypeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_upload_error_type(inputs)
	if (locale === "fr") return fr_onboarding_upload_error_type(inputs)
	if (locale === "es") return es_onboarding_upload_error_type(inputs)
	if (locale === "it") return it_onboarding_upload_error_type(inputs)
	if (locale === "nl") return nl_onboarding_upload_error_type(inputs)
	if (locale === "pl") return pl_onboarding_upload_error_type(inputs)
	if (locale === "fi") return fi_onboarding_upload_error_type(inputs)
	if (locale === "da") return da_onboarding_upload_error_type(inputs)
	if (locale === "sv") return sv_onboarding_upload_error_type(inputs)
	return en_onboarding_upload_error_type(inputs)
});